export enum StatesStyles {
    Contactado = 'chip--success',
    SinContactar = 'chip--warning',
    Archivado = 'chip--brand',
    'En curso' = 'chip--info',
    Emitida = 'chip--info'
}

export enum States {
    SinContactar  = 1,
    Leida = 2,
    Contactado = 3,
    Archivado = 5,
    'En curso' = 12,
    Emitida = 11
}
